import { type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (ContactImportWizard inkl. XLSX-Parsing) eager zu laden. Der Wizard kommt
 * über die Lazy-Route in App.tsx.
 */
const manifest: SkillManifest = {
  key: 'data-import',
  name: 'Datenimport',
  description: 'XLSX-/CSV-Import mit Field-Mapping.',
  category: 'data',
  version: '0.1.0',
  enabledByDefault: true,
};

export const dataImportSkill: FrontendSkill = { manifest };
